import React from 'react';
import { FadeIn } from './FadeIn';
export function OpeningHook() {
  return <section className="py-20 px-4 sm:px-6 lg:px-8 bg-brand-dark" data-id="element-99">
      <div className="max-w-5xl mx-auto" data-id="element-100">
        <FadeIn data-id="element-101">
          <div className="flex flex-col md:flex-row items-center gap-10 md:gap-14" data-id="element-102">
            <div className="flex-1 space-y-8 text-lg sm:text-xl text-brand-offwhite/90 font-serif italic leading-relaxed" data-id="element-103">
              <p data-id="element-104">
                Son las 2 de la mañana. Estás mirando el techo (o el celular de
                tu pareja) y sientes un vacío en el estómago que no te deja
                respirar. La traición no solo rompió un acuerdo; rompió tu
                realidad.
              </p>
              <p data-id="element-105">
                No sabes si gritar, llorar o actuar como si nada pasara para no
                destruir a tu familia. Pero el silencio te está matando por
                dentro y la duda de «¿qué hago ahora?» se repite en tu cabeza
                como un disco rayado.
              </p>
            </div>
            <div className="flex-shrink-0 w-64 sm:w-72 md:w-80" data-id="element-106">
              <img src="https://cdn.magicpatterns.com/uploads/qiQQVVzawyZV3phUidk56K/IMG_8531.png" alt="Persona despierta a las 2am" className="w-full rounded-2xl shadow-2xl border border-white/5" data-id="element-107" />
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}